import { Row } from '@stenajs-webui/core';
import { type ReactNode, useRef } from 'react';

export function CountryDropdownContent({
  countryCode,
  minWidth,
  children,
}: {
  countryCode: string;
  minWidth?: number;
  children: ReactNode;
}) {
  const flagSrc = `/img/flags/flags-iso/flat/svg/${countryCode}.svg`;
  const hasFallbackFlag = useRef(false);

  return (
    <Row gap alignItems={'center'} minWidth={minWidth}>
      <img
        src={flagSrc}
        alt={''}
        width={26}
        height={20}
        onError={e => {
          if (!hasFallbackFlag.current) {
            e.currentTarget.src = '/img/flags/flags-iso/flat/svg/_unknown.svg';
            hasFallbackFlag.current = true;
          } else {
            // Handle case where the fallback flag fails to load
            e.currentTarget.style.visibility = 'hidden';
            e.currentTarget.onerror = null;
          }
        }}
      />
      {children}
    </Row>
  );
}
